import i18next from 'i18next'
import en from './en'

i18next.init({
  lng: 'en',
  debug: false,
  resources: {
    en: {
      translation: en
    }
  }
})

export default key => i18next.t(key)



// WEBPACK FOOTER //
// ./src/config/translations/index.js